import {Button, Radio} from "antd";
import React, {useEffect, useState} from "react";
import {ListItems} from "../../../../CRUD/ListItems";
import {GetItem} from "../../../../CRUD/GetItem";
import {MapToolService} from "../../../../../service/mapToolService";
import {HandleAdd} from "../utils/HandleAdd";
import {HandleRemove} from "../utils/HandleRemove";
import i18next from "i18next";
import {sortableHandle} from "react-sortable-hoc";
import {MenuOutlined} from "@ant-design/icons";
import SortTable from "../utils/SortTable";

const MapToolsInMapTable = ({editMapConfig, setEditMapConfig, deleteTools, setDeleteTools, addTools, setAddTools, tools, setTools}) => {

    const [allTools, setAllTools] = useState()//for all tools from backend
    const [selectedValue, setSelectedValue] = useState()//hook for selected value
    const [selectedTool, setSelectedTool] = useState()//hook for selected tool
    const [order, setOrder] = useState()//order field hook
    const [toolsToSelect, setToolsToSelect] = useState([])//tools the user can select from dropdown

    const [randomNum, setRandomNum] = useState(generateRandomNumber());

    function generateRandomNumber() {
        const min = 30;
        const max = 100;
        const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
        return randomNumber;
    }

    const listAllTools = () => {
        ListItems(allTools, setAllTools, MapToolService.getAllTools)
    }

    const getSelectedTool = (id) => {
        GetItem(selectedTool, setSelectedTool, MapToolService.getTool, id)
    }

    let allToolstransform = []//for transforming all tools into a usable array with values

    let mapToolsTransrofm = []//for transforming current mapTools into a usable array with values

    let availableTools = []//allToolstransform - mapToolsTransrofm

    let mapToolsTranformsSort = []

    //load all tools
    useEffect(() => {
        listAllTools()
    }, [])

    useEffect(() => {

        if (allTools != undefined) {
            for (let i = 0; i < allTools.length; i++) {
                allToolstransform[i] = {
                    value: allTools[i].idMapTool,
                    label: allTools[i].name,
                }
            }
        }

        if (editMapConfig.map.mapMaptoolList != undefined) {
            for (let i = 0; i < editMapConfig.map.mapMaptoolList.length; i++) {
                mapToolsTransrofm[i] = {
                    value: editMapConfig.map.mapMaptoolList[i].mapTool.idMapTool,
                    label: editMapConfig.map.mapMaptoolList[i].mapTool.name,
                }
            }
        }

        if (editMapConfig.map.mapMaptoolList != undefined) {
            for (let i = 0; i < editMapConfig.map.mapMaptoolList.length; i++) {
                mapToolsTranformsSort[i] = {
                    conf: editMapConfig.map.mapMaptoolList[i].mapTool.conf,
                    idMapTool: editMapConfig.map.mapMaptoolList[i].mapTool.idMapTool,
                    name: editMapConfig.map.mapMaptoolList[i].mapTool.name,
                    idMapConf: editMapConfig.map.mapMaptoolList[i].sgvmapMapcnfMaptoolPK.idMapConf,
                    order: editMapConfig.map.mapMaptoolList[i].sgvmapMapcnfMaptoolPK.order,
                    index: editMapConfig.map.mapMaptoolList[i].sgvmapMapcnfMaptoolPK.order
                }
            }
        }

        setTools(mapToolsTranformsSort)
        availableTools = allToolstransform.filter(a => !mapToolsTransrofm.map(b => b.value).includes(a.value));
        setToolsToSelect(availableTools)
    }, [allTools])

    let toDeleteToolsList = []

    let toAddToolsList = []

    const renderSelected = (value) => {
        getSelectedTool(value)
        setSelectedValue(value)
    }

    const handleRemove = (mapTool) => {

        let mapId, toolId, toolName

        if (mapTool.sgvmapMapcnfMaptoolPK != undefined) {
            mapId = mapTool.sgvmapMapcnfMaptoolPK.idMapConf
            toolId = mapTool.mapTool.idMapTool
            toolName = mapTool.mapTool.name
        } else if (mapTool.joinTable != undefined) {
            mapId = mapTool.joinTable.idMapConf
            toolId = mapTool.mapToolOrLayer.idMapTool
            toolName = mapTool.mapToolOrLayer.name
        } else if (mapTool.index != undefined) {
            mapId = editMapConfig.map.idMapConf
            toolId = mapTool.idMapTool
            toolName = mapTool.name
        }

        HandleRemove(mapTool, tools, setTools, toDeleteToolsList, deleteTools, setDeleteTools,
            mapId, toolId, toolName, availableTools, toolsToSelect, setToolsToSelect,
            setSelectedValue, setOrder, setSelectedTool)
    }

    const handleAdd = () => {

        //console.log("order", order)
        //console.log("randomNum", randomNum)
        let joinTable = {
            idMapConf: editMapConfig.map.idMapConf,
            idMapToolOrLayer: selectedTool.idMapTool,
            order: parseInt(randomNum)
        };
        let item = {

            conf: selectedTool.conf,
            idMapTool: selectedTool.idMapTool,
            name: selectedTool.name,
            order: parseInt(randomNum),
            index: parseInt(randomNum)

        };

        setRandomNum(generateRandomNumber())

        HandleAdd(joinTable, item, setOrder, setSelectedTool,
            toAddToolsList, addTools, setAddTools, availableTools, setTools,
            selectedValue, setSelectedValue, toolsToSelect, setToolsToSelect)
    }

    const [selectedItems, setSelectedItems] = useState([]);

    const getColumns = () => {

        return [
            {
                title: i18next.t('common.tools.edit.sort'),
                dataIndex: "",
                width: '15%',
                className: "drag-visible",
                render: (d, dd, i) => (
                    <>
                        <DragHandle active={selectedItems.includes(i)}/>
                    </>
                )
            },
            {
                title: i18next.t('common.tools.edit.tool_name'),
                dataIndex: 'name',
                key: 'name'
            },
            {
                title: i18next.t('common.tools.edit.action'),
                key: 'action',
                render: (mapTool) =>
                    <Radio.Group>
                        <Button danger onClick={() => {
                            handleRemove(mapTool)
                        }} type="primary" id="toolDeleteButton">{i18next.t('common.tools.edit.delete')}</Button>

                    </Radio.Group>
            },
        ]
    };

    const DragHandle = sortableHandle(({active}) => (
        <MenuOutlined style={{cursor: "grab", color: active ? "blue" : "#999"}}/>
    ));

    return (
        <>
            <SortTable selectedItems={selectedItems} setSelectedItems={setSelectedItems}
                       items={tools} setItems={setTools} itemsToSelect={toolsToSelect}
                       renderSelected={renderSelected} order={order} setOrder={setOrder}
                       handleAdd={handleAdd} getColumns={getColumns} selectedValue={selectedValue} type="Tool"
                       randomNum={randomNum} setRandomNum={setRandomNum}/>
        </>
    )
}
export default MapToolsInMapTable;